import moment from 'moment-timezone';
import API, { ROUTES } from '../commons/api/api';
import {
  TIME_ZONE,
  IMAGE_PREVIEW_FORMAT,
  IMAGE_DETAIL_FORMAT,
} from '../commons/constans/moment';
import { v4 as uuidv4 } from 'uuid';

export const log = (debugVar, desc = false, type = false) => {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.REACT_APP_DEBUG_LOG === 'true'
  ) {
    if (desc) {
      let color = 'white';
      let bgc = 'black';
      let icon = '📌';
      switch (type) {
        case 'success':
          color = '#FFF';
          bgc = 'LimeGreen';
          icon = '✅';
          break;
        case 'info':
          color = '#FFF';
          bgc = 'Turquoise';
          icon = '❕';
          break;
        case 'error':
          color = 'Red';
          bgc = 'Black';
          break;
        case 'start':
          color = 'OliveDrab';
          bgc = 'PaleGreen';
          break;
        case 'warning':
          color = 'Tomato';
          bgc = 'Black';
          break;
        case 'end':
          color = 'Orchid';
          bgc = 'MediumVioletRed';
          break;
        default:
          color = 'white';
      }
      console.log(
        icon + ' %c' + desc,
        'color:' + color + ';font-weight:bold; background-color: ' + bgc + ';',
        debugVar
      );
    } else {
      console.log(debugVar);
    }
  }
};

export const randomIdentifier = () => {
  let id = (Math.random() * 1000).toString() + new Date().getTime().toString();
  return id;
};

export function priceFormat(price, n = 0, x = 3, s = ',', c = '.') {
  if (price) {
    price = +price;
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
    let num = price.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(
      new RegExp(re, 'g'),
      '$&' + (s || ',')
    );
  }
  return 0;
}

export function currencyFormat(number, separate = ',') {
  var string = number.toString();
  var regex = /\B(?=(\d{3})+(?!\d))/g;
  var res = string.replace(/,/g, '').replace(regex, separate);
  return res;
}

export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function formatPhoneNumber(phone) {
  var phoneFormat = phone;
  phoneFormat.replaceAll('', '-');
  var phoneArray = phone.split('');
  if (phone.length >= 8) {
    phoneArray.map((item, index) => {
      if (index === 2 || index === 6) {
        phoneArray[index] = item + '-';
      }
    });

    phoneFormat = phoneArray.join('');
  } else if (phone.length >= 4) {
    phoneArray.map((item, index) => {
      if (index === 2) {
        phoneArray[index] = item + '-';
      }
    });
    phoneFormat = phoneArray.join('');
  }
  return phoneFormat;
}

export function sliceIntoChunks(arr, chunkSize) {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

export function formatDateKorea(date) {
  let dateArr = date.split('-');
  if (dateArr.length === 3) {
    return `${dateArr[0]}년 ${dateArr[1]}월 ${dateArr[2]}일`;
  }
  return date;
}

export function rememberMeLogin(remember_me = true, token = '') {
  localStorage.setItem('remember_me', remember_me ? 1 : 0);
  localStorage.setItem('_APP_TOKEN', token);
  if (!remember_me) {
    sessionStorage.setItem('_APP_TOKEN', token);
  }
}

export function removeAllStorage() {
  let useTemplateLocal = window.localStorage.getItem('useTemplate');
  let useVideoMakerLocal = window.localStorage.getItem('useVideoMaker');
  let uids = window.localStorage.getItem('id_popup_merge');
  let appVersion = window.localStorage.getItem('APP_VERSION');
  localStorage.clear();
  sessionStorage.clear();
  window.localStorage.setItem('useTemplate', useTemplateLocal ?? null);
  window.localStorage.setItem('useVideoMaker', useVideoMakerLocal ?? null);
  window.localStorage.setItem('id_popup_merge', uids ?? null);
  window.localStorage.setItem('APP_VERSION', appVersion ?? null);
}

export function ploorPricePoint(price) {
  let result = 0;
  if (price > 1000) {
    result = Math.floor(price / 1000) * 1000;
  } else {
    result = price;
  }
  return result;
}

export function convertUrlTObject(url, type = 'album') {
  // if (!url) return null;
  // let dataArr = url.split('/');
  // let file_name = dataArr[dataArr.length - 1];
  // let bucket_name;
  // if (type == 'album') {
  //     bucket_name = `${dataArr[dataArr.length - 3]}/${dataArr[dataArr.length - 2]}`;
  // }else{
  //     bucket_name = `${dataArr[3]}`;
  // }
  // let baseUrl = url.replace(`${bucket_name}/${file_name}`, '');
  // let data = {
  //     baseUrl: baseUrl,
  //     bucketName: bucket_name,
  //     fileName: file_name,
  // }
  // return data;

  if (!url) return null;
  let urlObj = new URL(url);
  let baseUrl = urlObj.origin;
  let dataArr = urlObj.pathname.split('/');
  let file_name = dataArr[dataArr.length - 1];
  var newArr = dataArr.slice(0, -1);
  let bucket_name = newArr.join('/');
  let data = {
    baseUrl: baseUrl,
    bucketName: bucket_name,
    fileName: file_name,
    accessKey: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  };
  console.log('convertUrlTObject', data);
  return data;
}

export function debounce(func, wait = 300) {
  var timeout;

  return function () {
    var context = this,
      args = arguments;

    var executeFunction = function () {
      func.apply(context, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(executeFunction, wait);
  };
}

export function formatDateTimeStringKorea(data) {
  const format = 'dddd, YYYY-MM-DD, HH:mm a';
  let weekday = '';
  let time = '';
  let date = new Date(data);
  // let dateTime = moment(date).format(format);
  let dateTime = formatTimeZone(data, 'time');
  let datatimeArr = dateTime.split(', ');
  let dateYear = formatDateKorea(datatimeArr[1]);
  let timeArr = datatimeArr[2].split(' ');
  switch (datatimeArr[0]) {
    case 'Monday':
      weekday = '월요일';
      break;
    case 'Tuesday':
      weekday = '화요일';
      break;
    case 'Wednesday':
      weekday = '수요일';
      break;
    case 'Thursday':
      weekday = '목요일';
      break;
    case 'Friday':
      weekday = '금요일';
      break;
    case 'Saturday':
      weekday = '토요일';
      break;
    case 'Sunday':
      weekday = '일요일';
      break;

    default:
      break;
  }

  if (timeArr[1] === 'am') {
    time = '오전';
  } else {
    time = '오후';
  }
  let fullDateTime = ` ${dateYear} ${weekday} ${time} ${timeArr[0]} `;
  let timeStr = `${time} ${timeArr[0]}`;
  return {
    fullDateTime,
    dateYear,
    timeStr,
  };
}

export function formatTimeZone(dateTime, type) {
  if (!dateTime) return null;
  if (type == 'time') {
    return moment(dateTime).tz(TIME_ZONE).format(IMAGE_DETAIL_FORMAT);
  } else {
    return moment(dateTime).tz(TIME_ZONE).format(IMAGE_PREVIEW_FORMAT);
  }
}

export function addRankToEntries(entries, key = 'total_vote') {
  const map_key = entries.map((e) => e[key]);
  const ranks = map_key.map((v) => map_key.indexOf(v) + 1);

  return entries.map((e, index) => ({ ...e, rank: ranks[index] }));
}

export function formatSnsType(sns) {
  let snsType = '';
  switch (sns) {
    case 'GP':
      snsType = 'google';
      break;
    case 'NV':
      snsType = 'naver';
      break;
    case 'KT':
      snsType = 'kakao';
      break;
    case 'AP':
      snsType = 'apple';
      break;
  }
  return snsType;
}

export function formatAppSnsType(sns) {
  let snsType = '';

  switch (sns) {
    case 'google':
      snsType = 'GP';
      break;
    case 'naver':
      snsType = 'NV';
      break;
    case 'kakao':
      snsType = 'KT';
      break;
    case 'apple':
      snsType = 'AP';
      break;
  }

  return snsType;
}

export function checkImgUrl(url) {
  if (url) {
    let checkUrl = url.split(':')[0];
    if (checkUrl === 'http' || checkUrl === 'https') {
      return true;
    }
  }
  return false;
}

export function hasWhiteSpace(s) {
  return /\s/g.test(s);
}

export function shareKakaoTalk(
  title,
  message,
  url,
  thumbnail = '',
  pathName = '',
  linkRedirect = ''
) {
  let data = {
    title,
    message,
    url,
    thumbnail,
    pathName,
    linkRedirect,
  };
  console.log(data, 'shareKakaoTalk');
  window.nativeKakaoShare(data);
}

export function sharekakaoApi(data) {
  API.post(ROUTES.API_SHARE_KAKAO, data)
    .then((res) => {
      console.log(res, 'sharekakaoApi');
    })
    .catch((err) => {
      console.log(err, 'err');
    });
}

export function setLocalStorage(data) {
  let dataSave = {
    userId: data?.userId || null,
    day: new Date().toLocaleDateString('ko-KR'),
  };
  let dataLocal = window.localStorage.getItem(data?.name || null);
  let dataCheck = JSON.parse(dataLocal) ? JSON.parse(dataLocal) : [];
  dataCheck.push(dataSave);
  window.localStorage.setItem(data.name, JSON.stringify(dataCheck));
}

export function getDataLocalStorage(data) {
  let curentDay = new Date().toLocaleDateString('ko-KR');
  let dataLocal = window.localStorage.getItem(data?.name || null);
  let dataCheck = JSON.parse(dataLocal);
  let dataResult;
  let flag = false;

  if (dataCheck && dataCheck.length > 0) {
    dataResult = dataCheck.filter(function (item) {
      if (curentDay === item.day) return item;
    });
  }

  if (dataResult && dataResult.length > 0) {
    dataResult.map((item, idx) => {
      if (item.userId === data.userId) {
        if (curentDay === item.day) {
          flag = true;
        }
      }
    });
  }
  return flag;
}

export function validateKeyword(string, array) {
  string = ` ${string} `;
  string = string.replace(/(<span>|<\/span>)/gim, ' ');
  string = string.replace(/ /g, '  ');
  if (array.length > 0) {
    array.map((kw, idx) => {
      let kwr = ` ${kw.replace(/ /g, '  ')} `;
      let regex = new RegExp(kwr, 'gi');
      let error = ` <span>$&</span> `;
      string = string.replace(regex, error);
    });
    string = string.replace(/<span> /g, '<span>');
    string = string.replace(/ <\/span>/g, '</span> ');
    console.log(string, 'stringstring validateKeyword');
    return { status: true, html: ` ${string.trim().replace(/  +/g, ' ')} ` };
  } else {
    return { status: false, html: ` ${string.trim().replace(/  +/g, ' ')} ` };
  }
}

export function validateKoreanOnly(value){
  const re = /[\u3131-\uD79D | \s]/ugi;
  console.log(422, value.match(re));
  value = value.match(re)
  if (!value) {
    return '';
  }
  return value;
}

export function replaceCodeToInput(string, code = '') {
  string = string.replace(/{name}/gi, '<em class="name">$&</em>')
  console.log(string, 'stringstringstring');
  let regex1 = new RegExp(/{(.+?)}/, 'gim');
  let codeArr = string.match(regex1)
  let uniqueChars;
  if (codeArr?.length > 0) {
    uniqueChars = codeArr.filter((c, index) => {
      if (c !== '{name}') {
        return codeArr.indexOf(c) === index;
      }
    });
  }
  
  // let html = string.trim().replace(/  +/g, ' ');
  let html = string.trim();
  if (uniqueChars === null) return html;
  if (uniqueChars?.length > 0) {
    uniqueChars.map((item, idx) => {
			let codeNoSpace = item.trim()
      codeNoSpace = codeNoSpace.replace('{', '')
      codeNoSpace = codeNoSpace.replace('}', '')
      codeNoSpace = codeNoSpace
      let codeStr = `{${codeNoSpace}}`;
      console.log(codeNoSpace,codeStr, 'codeStr');
      let regex = new RegExp(codeStr, 'g');
      let input = `<label class="label" contenteditable="true" data-placeholder="${codeNoSpace}"></label>`;
      let text = html.replace(regex, input);
      html = text;
    });
  }
  return html;
}

export function converHtmlToDiv(data) {
  let arr = data.split('\n');
  let arrDiv = [];
  if (arr.length > 0 && arr[0] != '') {
    arr.map((item, idx) => {
      let html = `<div>${item}</div>`;
      arrDiv.push(html);
    });
  }
  return arrDiv.join('');
}

export function converHtmlToStr(data, code, character) { 
  const character_name = character === '차탄' ? 'chatan' : 'chuchu';
  console.log(character_name, 'character_name');
  console.log(479, data, code, character);
  console.log(481, data[character_name][+code-1][`template${code}`])
  let dataArr = data[character_name][+code-1][`template${code}`];
  let dataDiv = ''
  if (dataArr.length > 0) {
    dataArr.map((item, idx) => {
      dataDiv += item.text
    })
  }
  return dataDiv;
}

const getLastChar = (name, post1, post2) => {
  var lastChar = '';
  var index = (name.charCodeAt(name.length-1) - 44032) % 28;
  if(index > 0)
      return post2;
  else
      return post1;
}


export function replaceNameInTemplate(data, character, code, caseTem, name) {
  const character_name = character === '차탄' ? 'chatan' : 'chuchu';
  let dataArr = data[character_name][+code-1][`template${code}`];
  let dataDiv = '';
  let htmlHighLight = '';
  if (dataArr.length > 0) {
    dataArr.map((item, idx) => {
      if (item.case) {
        console.log(504, caseTem[`case${item.case}`][1], caseTem[`case${item.case}`][0], getLastChar(name, caseTem[`case${item.case}`][1], caseTem[`case${item.case}`][0]));
        const markedName = name + getLastChar(name, caseTem[`case${item.case}`][1], caseTem[`case${item.case}`][0]);
        let text = item.text.replace(/{name}/g, markedName)
            text = text.replace(/<div>/g, '');
            text = text.replace(/<\/div>/g, '\n');
        const textHl = item.text.replace(/{name}/g, `<em class="name">${markedName} </em>`)
        dataDiv += text;
        htmlHighLight += textHl
      }else{
        let textN = item.text.replace(/<div>/g, '');
            textN = textN.replace(/<\/div>/g, '\n');
        dataDiv += textN
        htmlHighLight += item.text
      }
    })
  }
  return {
    content: dataDiv,
    contentHighLight: htmlHighLight
  };
}

export function generateUuid() {
    let device_key = uuidv4().split('-').join('')
    localStorage.setItem('DEVICE_KEY', device_key);
    console.log(device_key, 'generateUuid');
    if(window.sendDeviceKey){
        window.sendDeviceKey(device_key);
    }
    return device_key;
}
